import type * as React from 'react'
import HashtagGroupWrapper from '~publish/legacy/hashtag-group-manager'
import { ComposerSidepanel } from '~publish/legacy/shared-components'

interface HashtagManagerSidepanelProps {
  onInsertHashtagGroupClick: (name: string, text: string) => void
  onClose: () => void
  onTop?: boolean
}

const HashtagManagerSidepanel: React.FC<HashtagManagerSidepanelProps> = ({
  onInsertHashtagGroupClick,
  onClose,
  onTop,
}) => {
  return (
    <ComposerSidepanel
      isVisible={true}
      customStyles={{
        height: '100%',
        zIndex: onTop ? '1' : '0',
      }}
      showCloseButton
      onClose={onClose}
    >
      <HashtagGroupWrapper
        viewMode="manageHashtag"
        onInsertHashtagGroupClick={onInsertHashtagGroupClick}
      />
    </ComposerSidepanel>
  )
}

export default HashtagManagerSidepanel
